module.exports = __webpack_public_path__ + "img/login-bg.53c4daab.svg";